import styled from '@emotion/styled';

export const MainWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '15px',
}));

export const AppWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: 'calc(100vh - 60px)',
  minWidth: '300px',
  minHeight: '300px',
  '@media(max-width: 768px)': {
    flexDirection: 'column',
    height: 'calc(max(700px, 100vh)',
  },
}));
